import { CommonModule } from '@angular/common';
import { Component, inject, signal, viewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Searchable } from '@components/ui/directives/searchable';
import { DataShare } from '@components/ui/share/share.type';
import { UiModule } from '@components/ui/ui-module';
import { Share } from '@models/binder.model';
import { BinderService } from '@services/binder.service';
import { Router } from '@services/route.service';

@Component({
  selector: 'lgb-share-list',
  imports: [
    UiModule,
    CommonModule,
    RouterModule
  ],
  templateUrl: './share-list.html',
  styleUrl: './share-list.css',
})
export class ShareList {
  //service
  readonly router=inject(Router);
  readonly binderS=inject(BinderService);

  //data
  readonly sharings=signal<Share[]>([]);
  readonly searchable=viewChild<Searchable>('searchable');

  //ui
  readonly loading=signal(true);
  readonly message=signal<string>(null);

  search$(){
    return (q: string, start: number, length: number) => this.binderS.getSharings(start, length);
  }

  url(share: Share){
    let data: DataShare=null;
    switch(share.type){
      case 'binder':
        data=this.binderS.getShareBinderData(share.element, share.ident);
        break;
      case 'page':
        data=this.binderS.getSharePageData(share.element, share.ident);
        break;
      case 'card':
        data=this.binderS.getShareCardData(share.element, share.ident);
        break;
      default:
        break;
    }

    return data.url;
  }

  disable(ident: string){
    this.loading.set(true);
    this.binderS.disableShare(ident)
      .subscribe(() => {
        this.message.set("Partage supprimé.");
        this.loading.set(false);
        this.searchable().lunchSearch();
      })
  }

}
